module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Uhr_Layer2.b2bb3734.svg";